/*!
 * Madosel Component 1.0.0-alpha12
 * Copyright 2020-2021 Kenan Gündoğan
 * https://www.madosel.com
 * Licensed under MIT https://github.com/kenangundogan/madosel/blob/master/LICENSE
 * Released under the MIT License
 */

require('./madosel-accordion.js');
require('./madosel-navigation-tabs.js');
require('./madosel-modal.js');
require('./madosel-offcanvas.js');
require('./madosel-dropdown.js');